var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_640_",
    d: "M111.41,66.54c0,0,8.82,1.53,8.82,11.03c0,8.38-6.44,11.69-12.87,11.69V66.54 H111.41z",
    style: {
      fill: "#DBA689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_639_",
    d: "M16.59,66.54c0,0-8.82,1.53-8.82,11.03c0,8.38,6.44,11.69,12.87,11.69V66.54 H16.59z",
    style: {
      fill: "#DBA689"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104,32.55c-9.61-14.17-22-19-40-19l0,0h0h0l0,0c-18,0-30.39,4.83-40,19 c-7.04,10.37-8.74,26.69-6.57,43.5c2.09,16.16,5.82,26,16.18,35.05c9,7.86,19.22,10.52,29.7,10.52c0.23,0,0.46,0,0.68,0h0 c0.23,0,0.46,0,0.68,0c10.48,0,20.71-2.66,29.7-10.52c10.36-9.05,14.09-18.89,16.18-35.05C112.74,59.24,111.04,42.92,104,32.55z",
    style: {
      fill: "#FADCBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_566_",
    d: "M69.23,90.19c-1.84,0.52-3.75,0.78-5.23,0.78c-1.48,0-3.39-0.25-5.23-0.78 c-0.79-0.22-1.1,0.52-0.82,1.02c0.58,1.03,2.94,3.1,6.04,3.1c3.11,0,5.46-2.07,6.04-3.1C70.33,90.71,70.02,89.97,69.23,90.19z",
    style: {
      fill: "#DBA689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_565_",
    d: "M73.26,99.45c-1.29,0-9.23,0-9.23,0s-7.93,0-9.23,0c-1.06,0-1.51,0.83-0.81,2.08 c0.98,1.75,4.61,5.11,10.04,5.11s9.06-3.36,10.04-5.11C74.77,100.29,74.31,99.45,73.26,99.45z",
    style: {
      fill: "#513F35"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    d: "M46.74,78.58c0,4.38-2.93,7.92-6.56,7.92c-3.62,0-6.57-3.55-6.57-7.92 c0-4.39,2.95-7.93,6.57-7.93C43.81,70.64,46.74,74.19,46.74,78.58",
    style: {
      fill: "#444444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_558_",
    d: "M94.39,78.58c0,4.38-2.93,7.92-6.56,7.92c-3.62,0-6.57-3.55-6.57-7.92 c0-4.39,2.95-7.93,6.57-7.93C91.46,70.64,94.39,74.19,94.39,78.58",
    style: {
      fill: "#444444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,13.68c6.2-0.42,11.38,3.07,11.13,8.45c-0.52,11.17-13.96,9.85-18.89,5.5 c-0.67-0.59-1.74-0.03-1.65,0.86c0.3,3,2.2,6.74,6.72,9.56c7.06,4.41,26.98,1.68,26.98-16.01c0-12.88-13.56-17.88-22.08-16.5 c-7.85,1.27-13.31,7.05-14.09,9.89C50.51,14.63,54.63,13.93,59.21,13.68z",
    style: {
      fill: "#312D2D"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.facb2fff7a32465741576694269f5be4.svg";
export { ForwardRef as ReactComponent };